<template>
    <footer>
        Copyright © {{ currentYear  }} Sistema de Gestión y Cobranza de Cartera Vencida de ADCTotal
    </footer>
</template>

<script>
    export default {
        name: 'FooterComponent',
        data: () => ({
            currentYear: new Date().getFullYear(),
        }),
    }
</script>

<style scoped>
    footer {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        /* border-top: 1px solid #CDCDCD; */
        background-color: #FFFFFF;
    }

</style>
